<template>
  <div>
    <HeaderBar>
      <v-icon slot="icon">phone</v-icon>
      SMS
    </HeaderBar>
    <v-layout column class="my-4">
      <v-flex>
        <v-autocomplete
          :items="recipients"
          item-text="displayName"
          item-value="phone"
          label="SMS Recipient"
          v-model="sendTo"
        />
      </v-flex>
      <v-layout row>
        <v-flex>
          <v-text-field
            label="SMS Message"
            v-model="sendMsg"
          />
        </v-flex>
        <v-btn @click="send" :loading="sendPending" :disabled="sendPending || (!sendTo || !sendMsg)" color="success">Send SMS</v-btn>
      </v-layout>
      <v-flex>
        <v-alert :value="sent" type="success">SMS Sent!</v-alert>
      </v-flex>
    </v-layout>
    <pre>
      DEBUG:
      send to: {{ sendTo }}
      send msg: {{ sendMsg }}
    </pre>
  </div>
</template>

<script>
import employeeApi from '@/api/employee'
import smsApi from '@/api/sms'

export default {
  data() {
    return {
      recipients: [],
      sendTo: '',
      sendMsg: '',
      sent: false,
      sendPending: false,
    }
  },

  mounted() {
    this.getSMSable()
  },

  methods: {
    send() {
      this.sendPending = true;
      smsApi.send({
        sendMsg: this.sendMsg,
        sendToNumber: this.sendTo
      })
      .then((r) => {
        console.log('r ', r)
        this.sent = true
      })
      .catch((e) => {
        console.log('e ', e)
        this.sent = false
      })
      .finally(() => {
        this.sendPending = false
        this.sendTo = ''
        this.sendMsg = ''
      })
    },

    getSMSable() {
      employeeApi.getSMSAble(
        (r) => {
          this.recipients = r.data
        },
        (e) => {
          console.log('error in getting smsables ', e)
        }
      )
    },

  },
}
</script>
